export const validationGroupResultColumn = [
  {
    title: 'Video',
    dataIndex: 'video',
    key: 'video',
    width: '15%',
  },
  {
    title: 'Image',
    dataIndex: 'image',
    key: 'image',
    width: '40%',
  },
  {
    title: 'File Name',
    dataIndex: 'fileName',
    key: 'fileName',
    width: '25%',
  },
  {
    title: 'Accuracy',
    dataIndex: 'accuracy',
    key: 'accuracy',
    width: '10%',
  },
  {
    title: 'Balanced Accuracy',
    dataIndex: 'balancedAccuracy',
    key: 'balancedAccuracy',
    width: '10%',
  },
];
